import { AccountingLedgerBasis } from "@common/types/domains/accounting/ledger";
import { EntityProfileIndustry, EntityProfileType } from "@common/types/entity";

// Minimal view of the source entity needed to prefill a template's header when
// the create starting point is "Copy from entity". Decoupled from the workspace
// list shape so this stays a pure, unit-testable mapper.
interface CopyEntitySource {
    legalType: EntityProfileType | null;
    industries: EntityProfileIndustry[];
}

export interface CopyEntityPrefill {
    entityLegalType: EntityProfileType | null;
    industries: EntityProfileIndustry[];
    basis: AccountingLedgerBasis[];
}

// Maps a source entity (+ its distinct ledger bases) onto the template header
// fields. Every value is left exactly as the source has it — including blanks:
// a missing legal type, no industries, or no bases each prefill empty, leaving
// the field editable (PRO-10008). Sets are de-duplicated.
export function buildCopyEntityPrefill({
    entity,
    ledgerBases,
}: {
    entity: CopyEntitySource;
    ledgerBases: AccountingLedgerBasis[];
}): CopyEntityPrefill {
    return {
        entityLegalType: entity.legalType,
        industries: [...new Set(entity.industries)],
        basis: [...new Set(ledgerBases)],
    };
}
